
const BASE_URL = 'https://www.x2077.top/api';

const WECHAT_LOGIN_CALLBACK_URL = `${BASE_URL}/wx/callback`
const WECHAT_LOGIN_CHECK_PATH = '/api/dingdang/checkLogin'

const GET_PRODUCTS_PATH = '/api/dingdang/getProducts'
const CREATE_ORDER_PATH = '/api/dingdang/createOrder'
const GET_MY_ORDERS_PATH = '/api/dingdang/getMyOrders'
const GET_LATEST_SUBSCRIPTION_PATH = '/api/dingdang/getLatestSubscription'
const GET_USERINFO_PATH = '/api/dingdang/getUserInfo'
const REPORT_BATCH_PHOTOS_PATH = '/api/dingdang/reportBatchPhotos'
const GET_ORDER_PATH = '/api/dingdang/getOrder'

const URLS = {
    WECHAT_LOGIN_CALLBACK_URL,
    WECHAT_LOGIN_CHECK_PATH,
    GET_PRODUCTS_PATH,
    CREATE_ORDER_PATH,
    GET_MY_ORDERS_PATH,
    GET_LATEST_SUBSCRIPTION_PATH,
    GET_USERINFO_PATH,
    REPORT_BATCH_PHOTOS_PATH,
    GET_ORDER_PATH,
}

export default URLS;